import { Grid } from "@mui/material";
import { Link } from "react-router-dom";

export const Options = () => {
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="text-center text-[#b91c1c] hover:underline"
        >
          <Link to="/auth/reset-password">¿Olvidaste tu contraseña? Dar click aquí</Link>
        </Grid>
      </Grid>
    </>
  );
};
